import i18next from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import HttpApi from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'
import de from '../locales/de.json'
import en from '../locales/en.json'
import pl from '../locales/pl.json'

export const defaultNS = 'local'
export const resources = {
  en: {
    local: en,
  },
  pl: {
    local: pl,
  },
  de: {
    local: de,
  },
}

// Rule disabled due to exported use in i18next. As long as this code
// is not modified, it's safe to disable the rule.
// eslint-disable-next-line import-x/no-named-as-default-member
const i18n = i18next
  .use(initReactI18next)
  .use(HttpApi)
  .use(LanguageDetector)
  .init({
    resources,
    defaultNS,
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false, // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    },
  })

i18next.on('languageChanged', (lng) => {
  document.documentElement.setAttribute('lang', lng)
})

export default i18n
